import React, { Component } from "react";
import Button from "@mui/material/Button";
import "../styles/home.css";
import { withRouter } from "react-router-dom";
import ModeSelectionPrompt from "../components/ModeSelectionPrompt";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { viewBackdrop: false };
    this.handleClose = this.handleClose.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleClose() {
    this.setState({ viewBackdrop: false });
  }

  handleToggle() {
    this.setState((prevState) => ({
      viewBackdrop: !prevState.viewBackdrop,
    }));
  }

  render() {
    return (
      <>
        <div className="centered-container">
          <Button
            variant="outlined"
            className="outlined-button outlined-button-white"
            onClick={() => {
              this.handleToggle();
              show("ButtonGroup");
            }}
          >
            Spustiť test
          </Button>
          <ModeSelectionPrompt
            historyPush={this.props.history.push}
            handleToggle={this.handleToggle}
            viewBackdrop={this.state.viewBackdrop}
            hide={hide}
          />
        </div>
      </>
    );
  }
}

function hide(id) {
  document.getElementById(id).style.display = "none";
}

function show(id) {
  document.getElementById(id).style.display = "initial";
}

export default withRouter(Home);
